import {FC, useEffect} from 'react';
import {Button, Form, Input, Modal, Select} from "antd";
import { useQuery } from "@tanstack/react-query";
import { JobExpType } from "../../../../services/types";
import { getJobExperience } from "../../../../services/api";
import {useMediaQuery} from "@uidotdev/usehooks";

export type initialValuesType = {
    employer_department: string
    employer_name: string
    employer_years: string
    employer_years_id: number
}

export type formValuesType = {
    values: {
        employer_name: string
        employer_department: string
        employer_years_id: number
    }
}

interface LastEmployerModalProps {
    visible: boolean;
    onCancel: () => void;
    onFinish: (values: formValuesType) => void;
    initialValues: initialValuesType;
    isLoading: boolean;
}

export const LastEmployerModal: FC<LastEmployerModalProps> = ({
                                                                        visible,
                                                                        onCancel,
                                                                        onFinish,
                                                                        initialValues,
                                                                        isLoading
                                                                    }) => {
    const { data: jobExperience } = useQuery({ queryKey: ['jobExperience'], queryFn: getJobExperience });
    const isMobile = useMediaQuery("only screen and (max-width : 768px)");

    const [form] = Form.useForm();

    useEffect(() => {
        form.setFieldsValue(initialValues);
    }, [form, initialValues]);

    const handleOk = () => {
        form.submit();
    };

    const experienceYearOptions = jobExperience?.map((year: JobExpType) => ({
        value: year.id,
        label: year.label
    }));

    return (
        <Modal
            open={visible}
            title="Ihr letzter Arbeitgeber"
            onCancel={onCancel}
            footer={[
                <Button key="cancel" onClick={onCancel}>
                    Abbrechen
                </Button>,
                <Button key="submit" type="primary" loading={isLoading} onClick={handleOk}>
                    Speichern
                </Button>
            ]}
        >
            <Form
                form={form}
                onFinish={onFinish}
                initialValues={initialValues}
            >
                <Form.Item name="employer_name" label="Name Ihres Arbeitgebers">
                    <Input size={isMobile? "large" : "middle"}/>
                </Form.Item>
                <Form.Item name="employer_department" label="Ihre Tätigkeiten">
                    <Input size={isMobile? "large" : "middle"}/>
                </Form.Item>
                <Form.Item name="employer_years_id" label="Verweildauer">
                    <Select options={experienceYearOptions} />
                </Form.Item>
            </Form>
        </Modal>
    );
};
